const addAutoplay = async (link) => {
  let newYT = await link.split('"');
  newYT[5] = (await newYT[5]) + "?autoplay=1";

  newYT = newYT.join('"');
  return newYT;
};

export default addAutoplay;
